module.exports = __webpack_public_path__ + "img/230.29711a47.jpg";